import moment from 'moment'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import InputDateRange from '../../../common/datePicker/InputDateRange'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { Element } from '../../../common/html/element'
import { Radio } from '../../../common/html/radio'
import {
  FORMAT,
  getCurrentDateTime,
  getISOStartOrEndOfDay,
} from '../../../helpers/datetime'
import { TIME_PERIOD_LIST } from '../constants'
import classes from '../NewsAndSocialContent.module.scss'
import {
  changeActiveTimePeriod,
  changeEndDate,
  changeStartDate,
  selectActiveTimePeriod,
  selectEndDate,
  selectStartDate,
} from '../store/slice'
import { RadioDateRangeCustom } from './RadioDateRangeCustom'

export const FilterListTimePeriodRadio = ({ title }) => {
  const dispatch = useDispatch()
  const timezone = UseTimeZone()

  const locale = useSelector((state) => state.i18n.locale)
  const activeTimePeriod = useSelector(selectActiveTimePeriod)
  const startDate = useSelector(selectStartDate)
  const endDate = useSelector(selectEndDate)

  const currentDate = getCurrentDateTime(FORMAT.DATE_PICKER, locale, timezone)
  const endDateOfCurrentDate = getISOStartOrEndOfDay(
    currentDate,
    timezone,
    true,
  )
  useEffect(() => {
    switch (activeTimePeriod.value) {
      case TIME_PERIOD_LIST.allTime.value:
        const startDateAllTime = moment(currentDate)
          .subtract(5, 'years')
          .toISOString()
        dispatch(changeStartDate(startDateAllTime))
        dispatch(changeEndDate(endDateOfCurrentDate))
        break
      case TIME_PERIOD_LIST.past30Days.value:
        const startDate30days = moment(currentDate)
          .subtract(30, 'days')
          .toISOString()
        dispatch(changeStartDate(startDate30days))
        dispatch(changeEndDate(endDateOfCurrentDate))
        break
      case TIME_PERIOD_LIST.past90Days.value:
        const startDate90days = moment(currentDate)
          .subtract(90, 'days')
          .toISOString()
        dispatch(changeStartDate(startDate90days))
        dispatch(changeEndDate(endDateOfCurrentDate))
        break
      case TIME_PERIOD_LIST.past6Months.value:
        const startDate6Months = moment(currentDate)
          .subtract(6, 'months')
          .toISOString()
        dispatch(changeStartDate(startDate6Months))
        dispatch(changeEndDate(endDateOfCurrentDate))
        break
      case TIME_PERIOD_LIST.past1Year.value:
        const startDate1Year = moment(currentDate)
          .subtract(1, 'years')
          .toISOString()
        dispatch(changeStartDate(startDate1Year))
        dispatch(changeEndDate(endDateOfCurrentDate))
        break
      default:
        break
    }
  }, [activeTimePeriod])

  const changeTimePeriod = (value) => {
    const activeItem = Object.values(TIME_PERIOD_LIST).find(
      (item) => item.value === value,
    )
    dispatch(changeActiveTimePeriod(activeItem))
  }

  const onOkDatePicker = ({ startDate, endDate }) => {
    dispatch(changeStartDate(startDate))
    dispatch(changeEndDate(endDate))
    dispatch(changeActiveTimePeriod(TIME_PERIOD_LIST.customDate))
  }

  return (
    <div>
      <Element
        style={{ color: '#2B457D' }}
        className={[
          'dFlex justifyContentBetween alignItemsCenter textUppercase fw600',
          classes.checkboxItem,
        ].join(' ')}
      >
        <Translate style={{ padding: '6px 0' }} value={title} />
      </Element>
      {Object.values(TIME_PERIOD_LIST).map((item) => {
        if (item.value !== TIME_PERIOD_LIST.customDate.value) {
          return (
            <Element
              key={item.value}
              className={[
                'dFlex justifyContentBetween alignItemsCenter',
                classes.checkboxItem,
              ].join(' ')}
              style={{ padding: '4px 0' }}
            >
              <Radio
                {...item}
                key={item.value}
                activeValue={activeTimePeriod.value}
                onChange={changeTimePeriod}
              />
            </Element>
          )
        } else {
          return (
            <InputDateRange
              key={item.value}
              scrollId="companyAnalysis"
              defaultStartDate={
                activeTimePeriod.value === TIME_PERIOD_LIST.customDate.value
                  ? startDate
                  : moment(currentDate).subtract(7, 'days').toISOString()
              }
              defaultEndDate={
                activeTimePeriod.value === TIME_PERIOD_LIST.customDate.value
                  ? endDate
                  : currentDate
              }
              maxDate={currentDate}
              minDate={moment(currentDate).subtract(5, 'years').toISOString()}
              children={
                <RadioDateRangeCustom
                  {...item}
                  key={item.value}
                  activeValue={activeTimePeriod.value}
                />
              }
              onSubmit={onOkDatePicker}
            />
          )
        }
      })}
    </div>
  )
}
